import AadhaarInputComponent from "../../../molecules/hpr-hfr-dhis/aadhaar-input";

const AadhaarField = ({
  aadharNumber,
  setAadharNumber,
  handleGetOtp,
}: {
  aadharNumber: string;
  setAadharNumber: (number: string) => void;
  handleGetOtp: ({
    aadhaar,
    resend,
  }: {
    aadhaar: string;
    resend?: boolean | undefined;
  }) => Promise<void>;
}) => {
  return (
    <div className="dr-to-darwin-touch-neutral-300 dr-rounded-8">
      <AadhaarInputComponent
        className={"mt-16"}
        initialValue={aadharNumber}
        onChange={async (val) => {
          setAadharNumber(val);
          if (val.length === 12) {
            handleGetOtp({ aadhaar: val });
          }
        }}
      />
    </div>
  );
};

export default AadhaarField;
